import React from "react"
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
} from 'chart.js'
import { Line } from 'react-chartjs-2'
import { useSelector } from "react-redux"

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend
)

const GComision = () => {

    const meses = useSelector(store => store.cotizacion.meses);
    const datos = useSelector(store => store.cotizacion.datos);

    const options = {
        responsive: true,
        scales: {
            yAxis: {
              min: 0
            }
        },
        plugins: {
            legend: {
                position: 'top',
            },
           
            // title: {
            //     display: true,
            //     text: 'Ventas por mes',
            // },
        }
       
    };
    const data = {
        labels: meses,
        datasets: [
            {
                fill: true,
                label: 'ventas',
                data: datos,
                backgroundColor: "rgba(75,192,192,0.2)",
                borderColor: "rgba(75,192,192,1)"
            },
        ],
    };

    return (
        <div  style={{width:"100%", maxWidth:"700px"}}>
            <Line options={options} data={data} />
        </div>
    )
}

export default GComision